/**
 * Interface
 */

import { toRaw, unref } from "vue";

export default class ReadOnlyAnalyzer {
  constructor(name) {
    this.name = name;
  }

  /**
   * 
   * @param {import("../xmlrdb-data/Attribute").default} [attribute] from  xmlrdb-data/Attribute
   * @returns 
   */
  isReadOnly(attribute) {
    return false;
  }
}

/**
 * 
 * @param {ReadOnlyAnalyzer | Function | Boolean | import("vue").Ref<ReadOnlyAnalyzer | Function | Boolean>} roa 
 * @returns {ReadOnlyAnalyzer}
 */
export function normalizeReadOnlyAnalyzer(roa) {
  const unrefed = unref(roa);
  if (unrefed === undefined || unrefed === null) {
    return { name: "normalized", isReadOnly() { return true; } };
  }
  else if (typeof unrefed === "boolean") {
    return { name: "normalized", isReadOnly() { return unrefed; } };
  }
  else if (typeof unrefed === "function") {
    return { name: "normalized", isReadOnly(attribute, dataElement) { return unrefed(attribute, dataElement ?? attribute?.dataElement); } };
  }
  // @ts-ignore
  else if (unrefed instanceof ReadOnlyAnalyzer || typeof unrefed.isReadOnly === "function" ) {
    // @ts-ignore
    return toRaw(unrefed);  // Jahre meines Lebens: Wie wird man all den Vue-Ueberbau sicher los!?
  }
  throw new Error("übergebens Objekt kann nicht in einen ReadOnlyAnalyzer konvertiert werden")
}